const setHandoff = (state, handoff) => {
  Object.assign(state, { handoff })
}

const addComment = (state, comment) => {
  state.handoff.unshift(comment)
}

export default {
  setHandoff,
  addComment
}
